import { BaseComponent, Component, Ref } from "@eastsideco/salvo-ts";
import { ThemeComponent } from "@/theme/ThemeComponent";

/**
 * A form which allows customers to select product options and then
 * add the matching variant and quantity to the cart.
 */
@Component
export class ReadMore extends ThemeComponent {
    @Ref() more!: HTMLDivElement;
    @Ref() less!: HTMLDivElement;
    @Ref() moreAction!: HTMLButtonElement;
    @Ref() lessAction!: HTMLButtonElement;

    private accordionBody: HTMLElement | null = this.closest('.accordion__body');
    private initialHeight = this.accordionBody?.scrollHeight;

    init() {
        this.$listen(this.moreAction, 'click', () => {
            this.toggleDescription();
            this.handleAccordion('more');
        });

        this.$listen(this.lessAction, 'click', () => {
            this.toggleDescription();
            this.handleAccordion('less');
        });
    }

    toggleDescription() {
        this.more.classList.toggle('is-active');
        this.less.classList.toggle('is-active');
        this.moreAction.classList.toggle('is-active');
        this.lessAction.classList.toggle('is-active');
    }

    handleAccordion(action: string) {
        if (!this.accordionBody) { return; }
        if (action == 'more') {
            this.accordionBody.style.height = `${this.accordionBody.scrollHeight}px`;
        } else {
            this.accordionBody.style.height = `${this.initialHeight}px`;
        }
    }
}
